import React from 'react'
import { useThemeContext } from '../contexts/ThemeContext'

export const Layout = ({children, isMobile}) => {
  const theme = useThemeContext()
  return (

    <div className="flex-1" data-theme={theme}>
      {/* <Topnav isMobile={isMobile} /> */}
      <div style={{ maxWidth: '100%'}} className="p-0">
        {children}
      </div>
      {/* <MainFooter /> */}

      {/* <HomePage /> */}
    </div>
  )
}
